import React from 'react';

import { Button, Group, Stack, useMantineTheme } from '@mantine/core';
import ImageUploader from 'components/ImageUploader';
import SharedPaymentMethodsAlert from 'components/SharedPaymentMethodsAlert';
import { useAuth } from 'context/auth-context';
import useAthleteIsSharingPaymentMethods from 'hooks/athlete/useAthleteIsSharingPaymentMethods';
import SimpleHeader from 'layouts/MobileLayout/components/SimpleHeader';

import AthleteAccountForm from './components/AthleteAccountForm';
import PaymentMethods from './components/PaymentMethods';

const Account = (): JSX.Element => {
  const theme = useMantineTheme();
  const { session, clearProfile, logout, stopImpersonation } = useAuth();
  const isSharingPaymentMethods = useAthleteIsSharingPaymentMethods(session?.athlete?.athleteId);

  const isImpersonating = session?.isImpersonating;

  return (
    <>
      <SimpleHeader title='Account' />
      <Stack className='content'>
        <ImageUploader />
        <AthleteAccountForm />
        <PaymentMethods />
        {isSharingPaymentMethods && <SharedPaymentMethodsAlert sx={{ marginBottom: '1rem' }} />}
        <Group grow my='md' spacing='md'>
          {isImpersonating ? (
            <Button
              color='red'
              variant='light'
              onClick={stopImpersonation}
              size='sm'
              sx={{ boxShadow: theme.shadows.md }}
            >
              Stop Impersonation
            </Button>
          ) : (
            <Button variant='light' onClick={clearProfile} size='sm' sx={{ boxShadow: theme.shadows.md }}>
              Switch Profiles
            </Button>
          )}
          <Button
            color='red'
            variant='light'
            onClick={logout}
            size='sm'
            sx={{ boxShadow: theme.shadows.md }}
          >
            Log Out
          </Button>
        </Group>
      </Stack>
    </>
  );
};

export default Account;
